import { useEffect, useState } from 'react';

import {
  GET_ALL_SWING_CONTRACT_TYPE,
  SWING_CONTRACT_MESSAGES,
} from '../../../constants/FieldNomsSwingContract';
import { HTTPS_STATUS_CODES } from '../../../constants/Common';
import { get } from '../../../services/GenesisApi';
import { sendNotification } from '../../../UI/Notification';

interface SwingContractType {
  id: string;
  name: string;
}

const { FAILED_FETCH_SWING_CONTRACT_TYPES } = SWING_CONTRACT_MESSAGES;

const useGetAllSwingContractType = () => {
  const [swingContractTypes, setSwingContractTypes] = useState<
    SwingContractType[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const getAllSwingContractType = (): Promise<SwingContractType[]> => {
    setLoading(true);
    setError(null);

    return get(GET_ALL_SWING_CONTRACT_TYPE)
      .then((res) => {
        if (res.status === HTTPS_STATUS_CODES.SUCCESS) {
          const { data } = res;
          setSwingContractTypes(data);
          return data;
        }

        throw new Error(res.statusText ?? FAILED_FETCH_SWING_CONTRACT_TYPES);
      })
      .catch((err) => {
        setError(err ?? FAILED_FETCH_SWING_CONTRACT_TYPES);
        sendNotification({
          type: 'error',
          message: err ?? FAILED_FETCH_SWING_CONTRACT_TYPES,
        });
        return [];
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getAllSwingContractType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { swingContractTypes, loading, error, getAllSwingContractType };
};

export default useGetAllSwingContractType;
